const HTTP = 'http';
const FULL_HTTP = 'http://';

export default function getLinkURL(link) {
    if (link.startsWith('mailto:')) {
        return link;
    }
    return link.substr(0, 4) === HTTP ? link : FULL_HTTP + link;
}